import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { Redirect, Route } from "react-router-dom";
import { AuthContext } from "../../App";

const ProtectedRoute = ({ component: Component, pagePermission, ...rest }) => {
  const { state } = useContext(AuthContext);
  const [permissionGranted, setPermissionGranted] = useState(null);
  useEffect(() => {
    if (typeof pagePermission === "number") {
      let permissions = [];
      if (state.permissions.length > 0) {
        permissions = state.permissions;
      } else if (localStorage.getItem("permissions")) {
        permissions = localStorage
          .getItem("permissions")
          .split(",")
          .map((ele) => parseInt(ele));
      }
      setPermissionGranted(permissions.includes(pagePermission));
    }
  }, [pagePermission]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (permissionGranted !== null) {
          if (
            (state.userId || localStorage.getItem("userId")) &&
            (state.userGroupId || localStorage.getItem("userGroupId")) && 
            moment(moment(localStorage.getItem("pwExpiry"))).diff(Date.now()) >
              0
          ) {
            if (permissionGranted) {
              return <Component {...rest} />;
            }
            return (
              <Redirect
                to={{
                  pathname: "/forbidden",
                }}
              />
            );
          }
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
